import { apiRequest } from "../utils/useAPIRequest";
import { exchangeStore } from "../stores";
import constant from "../utils/constant";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

const useGetExchangeTransactions = (
  exchangeTranTableQuery,
  filterQuery,
  searchQuery
) => {
  const query = useMemo(() => {
    if (searchQuery) {
      return `${exchangeTranTableQuery}&search=${searchQuery}`;
    } else if (filterQuery) {
      return `${exchangeTranTableQuery}&${filterQuery}`;
    } else {
      return exchangeTranTableQuery;
    }
  }, [filterQuery, exchangeTranTableQuery, searchQuery]);

  return useQuery({
    queryKey: ["getExchangeTransactions", query],
    queryFn: () => {
      return apiRequest({
        url: `/exchangeRates/history?${query}`,
        method: "get",
      });
    },
    keepPreviousData: true,
  });
};

const getExchangeRate = async () => {
  const { status, data, errorMessage } = await apiRequest({
    url: "/exchangeRates",
    method: "get",
  });
  if (status === constant.Success) {
    exchangeStore.setExchangeRate(data);
    return { status };
  }
  return { errorMessage, status };
};

const getExchangeAnalysis = async (query) => {
  if (!query) {
    query = "";
  }
  const { status, data, errorMessage } = await apiRequest({
    url: `/exchangeRates/history-analysis?${query}`,
    method: "get",
  });
  if (status === constant.Success) {
    exchangeStore.setExchangeAnalysis(data);
    return { status };
  }
  return { errorMessage, status };
};

const createExchangeRate = async (payload) => {
  const { status, errorMessage, data } = await apiRequest({
    url: "/exchangeRates/exchange-rate",
    method: "post",
    payload,
  });
  if (status === constant.Success) {
    await Promise.all([
      getExchangeRate(),
      // WalletController.walletDetails(),
    ]);
    return { status: constant.Success, data };
  }
  return { errorMessage, status, data };
};

// const getExchangeRateAmount = async query => {
// 	const { status, data, errorMessage } = await apiRequest({
// 		url: `/exchangeRates/rate-amount?${query}`,
// 		method: 'get',
// 	});
// 	if (status === constant.Success) {
// 		exchangeStore.setExchangeRateValue(Math.floor(data.amount * 100) / 100);
// 		return { status: constant.Success, data };
// 	}
// 	return { errorMessage, status };
// };

export default {
  getExchangeRate,
  createExchangeRate,
  getExchangeAnalysis,
  useGetExchangeTransactions,
};
